import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import type { ReactNode } from 'react';

export interface AlertState {
  text: string;
  show: boolean;
  setAlert: (t: string) => void;
  hideAlert: () => void;
}

const AlertContext = createContext<AlertState | null>(null);
AlertContext.displayName = 'Alert';

export function AlertProvider({ children }: { children: ReactNode }) {
  const [text, setText] = useState('');
  const [show, setShow] = useState(false);

  const setAlert = useCallback((t: string) => {
    setText(t);
    setShow(true);
  }, []);

  const hideAlert = useCallback(() => {
    setText('');
    setShow(false);
  }, []);

  const value = useMemo(
    () => ({ text, show, setAlert, hideAlert }),
    [text, show, setAlert, hideAlert]
  );

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
}

export function useAlert(): AlertState {
  const ctx = useContext(AlertContext);
  if (!ctx) {
    throw new Error('Alert not provided');
  }
  return ctx;
}
